import { webCrypto } from '#web-crypto';
import { base64ToArray } from './binary-utils';
import { AES_SECRET_DERIVE_HASH_FUNCTION, AES_SECRET_DERIVE_INFO, } from './constants';
import { hkdfDeriveAesKey } from './hkdf';
export const importAesSecret = async (aesSecret) => {
    const aesSecretBuffer = new Uint8Array(base64ToArray(aesSecret));
    const importedAesSecret = webCrypto.subtle.importKey('raw', aesSecretBuffer, 'HKDF', false, ['deriveBits', 'deriveKey']);
    const size = aesSecretBuffer.byteLength;
    aesSecretBuffer.fill(0, size);
    return importedAesSecret;
};
export const deriveAesSecretKey = async (aesSecret, salt) => {
    const importedAesSecret = await importAesSecret(aesSecret);
    const aesSecretKey = await hkdfDeriveAesKey(importedAesSecret, base64ToArray(salt), AES_SECRET_DERIVE_HASH_FUNCTION, base64ToArray(AES_SECRET_DERIVE_INFO));
    return aesSecretKey;
};
